import React from 'react';
export function ReceiptFooter() {
  const currentDate = new Date().toLocaleString('en-SG', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  return <div className="pt-5 border-t border-neutral-200 text-center space-y-1" data-id="element-1010">
      <p className="text-xs text-neutral-500" data-id="element-1011">
        Generated by system on {currentDate}
      </p>
      <p className="text-xs text-neutral-500 italic" data-id="element-1012">
        This is a computer-generated document. No signature is required.
      </p>
    </div>;
}